export class Links{
url:string
id:string
description:string
tags:any
linkTypeId:number
title:string;
category:string;
selectedTag: string
}